<template>
	<div id="app">
		<component :is="layout">
			<RouterView />
		</component>
	</div>
</template>

<script>
import WithFilterLayout from "./layouts/WithFilter"
import WithoutFilterLayout from "./layouts/WithoutFilter"
import LayoutBaseWithCap from "@/layouts/LayoutBaseWithCap.vue";
import LayoutLoginV2 from "./layouts/LayoutLoginV2"
import LayoutAuth from './layouts/LayoutAuth.vue';
import LayoutBase from './layouts/LayoutBase.vue';
export default {
	name: 'App',
	components: {
		WithFilterLayout,
		WithoutFilterLayout,
		LayoutLoginV2,
		LayoutAuth,
		LayoutBase,
        LayoutBaseWithCap
	},
	computed: {
		layout() {
			return (this.$route.meta.layout || 'LayoutBase')
		}
	},
	created() {
        document.title = this.$route.meta.title || 'Buyerdesk'
    }
}
</script>
